import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  // FAQ
  {
    path: '/faq/:categoryId?/:faqId?',
    name: 'FAQ',
    meta: {
      title: 'eznatal | FAQ'
    },

    component: () => import(/* webpackChunkName: "faq" */ '../views/FaqDetails')
  },
  // Blog
  {
    path: '/blog',
    name: 'Blog',
    meta: {
      title: 'eznatal | Blog'
    },

    component: () =>
      import(/* webpackChunkName: "Blog" */ '../views/BlogSection')
  },
  {
    path: '/blog/:Id',
    name: 'BlogDetails',
    meta: {
      title: 'eznatal | Blog'
    },

    component: () =>
      import(/* webpackChunkName: "BlogDetails" */ '../views/BlogDetails')
  },
  {
    path: '/tutorials',
    name: 'TutorialList',

    meta: {
      title: 'eznatal | Tutorial'
    },
    component: () =>
      import(
        /* webpackChunkName: "TutorialDetails" */ '../views/TutorialList.vue'
      )
  },
  {
    path: '/tutorial/:tutorialId',
    name: 'TutorialDetails',

    meta: {
      title: 'eznatal | Tutorial'
    },
    component: () =>
      import(
        /* webpackChunkName: "TutorialDetails" */ '../views/TutorialDetails.vue'
      )
  },
  {
    path: '/login',
    name: 'Login for Support Request',

    meta: {
      title: 'eznatal | Login'
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../components/Pages/Login/login.vue'
      )
  },
  {
    path: '/support-request',
    name: 'SupportRequest',

    meta: {
      title: 'eznatal | Support Request'
    },
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SupportTicket.vue')
  },
  {
    path: '/feedback-details/:feedbackId',
    name: 'Feedback',

    meta: {
      title: 'eznatal | Feedback'
    },
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/TicketDetails.vue')
  },
  // Release Notes
  {
    path: '/release/:Id?',
    name: 'ReleaseNotes',
    meta: {
      title: 'eznatal | Release'
    },

    component: () =>
      import(/* webpackChunkName: "Blog" */ '../views/ReleaseNotes.vue')
  },
  // News
  {
    path: '/news',
    name: 'News',
    meta: {
      title: 'eznatal | News'
    },

    component: () =>
      import(/* webpackChunkName: "Blog" */ '../views/News.vue')
  },
  {
    path: '/news/:Id',
    name: 'NewsDetails',
    meta: {
      title: 'eznatal | News'
    },

    component: () =>
      import(/* webpackChunkName: "BlogDetails" */ '../views/NewsDetails')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  var currentRoute = to.path
  const loggedIn = localStorage.getItem('MomsiteAccessToken')
  if (currentRoute.includes('/support-request') && !loggedIn) {
    next('/login')
  } else if (loggedIn && currentRoute.includes('/login')) {
    next('/')
  } else {
    next()
  }
})

export default router
